// document.addEventListener("DOMContentLoaded", function () {
//   const slider = document.querySelector(".category-slider");
//   if (slider) {
//     slider.style.scrollBehavior = "smooth";
//   }
// });
document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".category-slider");
  const leftArrow = document.querySelector(".slider-arrow.left");
  const rightArrow = document.querySelector(".slider-arrow.right");

  if (slider && leftArrow && rightArrow) {
    const scrollAmount = 200;

    const updateArrowVisibility = () => {
      if (slider.scrollLeft > 0) {
        leftArrow.classList.add("show");
      } else {
        leftArrow.classList.remove("show");
      }
    };

    leftArrow.addEventListener("click", () => {
      slider.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      setTimeout(updateArrowVisibility, 300); // wait for scroll
    });

    rightArrow.addEventListener("click", () => {
      slider.scrollBy({ left: scrollAmount, behavior: "smooth" });
      setTimeout(updateArrowVisibility, 300); // wait for scroll
    });

    // Optional: update visibility on manual scroll too
    slider.addEventListener("scroll", updateArrowVisibility);
  }
});
